import React, { useState } from 'react';
import { Modal, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Loader from '../Utility/Loader/Loader';
import CustomDatePicker from '../Utility/DatePicker/DatePicker';

function CustomConfirmationPopup({
  onOpen,
  onConfirm,
  message,
  secondMessage,
  toggle,
  title,
  loading,
  deleteById,
  commentText,
  isCommentOn,
  showCheckBox,
  disabledBtn,
  showThirdMsg,
  thirdMessage,
  showDate,
  setSelectedDate,
  selectedDate,
  customClass,
  customCommentLabel,
  comment,
  errorSheetUrl,
  onCancel,
}) {
  const [allowDelete, setAllowDelete] = useState(false);
  const { t } = useTranslation('common');
  const deleteCompletly = (e) => {
    if (showCheckBox) {
      setAllowDelete(e.target.checked);
    }
  };

  const handleDateChange = (e) => {
    setSelectedDate(e);
  };

  const handleCancel = () => {
    if (errorSheetUrl) {
      window.open(errorSheetUrl, '_blank');
    }
    if (onCancel) {
      onCancel();
    } else {
      toggle();
    }
  };

  return (
    <Modal
      show={onOpen}
      backdrop="static"
      className={customClass ? `common-custom-modal ${customClass} modal-medium` : 'common-custom-modal modal-medium'}
      aria-labelledby="contained-modal-title-vcenter"
      onHide={toggle}
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          <span className="f-16 text-bold">{title}</span>
        </Modal.Title>
        <span onClick={toggle} className="icon-close ml-auto cursor-pointer" />
      </Modal.Header>
      <Modal.Body className="design-archive-body">
        {loading && <Loader />}
        {!loading && (
          <>
            <span>
              <p className="common-margin text-center">{message}</p>
              {showCheckBox ? (
                <div className="checkbox-label">
                  <input type="checkbox" id="delConfirm" name="delConfirm" onChange={deleteCompletly} value="delete" />
                  <label htmlFor="delConfirm" className="chklabel align-items-start">
                    <p>{secondMessage}</p>
                  </label>
                </div>
              ) : (
                secondMessage && <p className="common-margin text-center">{secondMessage}</p>
              )}
            </span>
            {showThirdMsg && (
              <span>
                <p>{thirdMessage}</p>
              </span>
            )}
            {showDate && (
              <div className="date justify-content-end px-1">
                <div className="input-button-container">
                  <CustomDatePicker
                    dateFormat="dd-MMM-yyyy"
                    name="deliveryDate"
                    popperPlace="bottom-end"
                    placeholder={t('CUSTOM_CONFIRMATION_POPUP.DELIVERY_DATE_PLACEHOLDER')}
                    onChange={handleDateChange}
                    valueProp={selectedDate ? new Date(selectedDate) : null}
                  />
                </div>
              </div>
            )}
            {isCommentOn && (
              <div className="common-input-control">
                <span>
                  <label>{customCommentLabel}</label>
                </span>
                <textarea
                  className="form-control"
                  rows="4"
                  onChange={commentText}
                  placeholder={t('CUSTOM_CONFIRMATION_POPUP.ENTER_COMMENT')}
                  maxLength="200"
                  value={comment}
                />
                <span className="character-counter">{comment?.length || 0}/200</span>
              </div>
            )}
            <div className="common-model-footer mt-3">
              <button type="button" aria-label="save" onClick={onConfirm} className="btn p-0" disabled={(showCheckBox && !allowDelete) || disabledBtn}>
                <i className="icon-Tick-1 f-24" />
              </button>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default CustomConfirmationPopup;
